import { LRUCache } from 'src/common/utils/lru-cache';

export const foldListExpandInfo = new LRUCache<string, boolean>(
  localStorage,
  'expand-block-list',
  1000
);
